import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import Breakpoints from 'utils/Breakpoints';
import { Types as UserTypes } from '../../store/user';

import ModuleLogo from 'images/loginImage.svg';
import Logo from 'images/logo.png';
import BackgroundVertical from 'images/backgroundVertical.jpg';
import BackgroundHorizontal from 'images/backgroundHorizontal.jpg';

import FormLabelAndInput from '../../components/UI/Form/LabelAndInput';
import Button from '../../components/UI/Button/Button';
import Messages from '../../components/UI/Messages/Messages';


import './Login.css';
import Footer from 'components/Layout/Footer/Footer';

function Login({ history }) {
  const [auth, setAuth] = useState({ username: '', password: '' });
  const dispatch = useDispatch();

  function submit(event) {
    event.preventDefault();

    dispatch({
      type: UserTypes.REQUEST_LOGIN,
      payload: {
        data: auth,
        callback: () => {
          history.push('/');
        }
      }
    });
  }

  return (
    <div className="login-wrapper" style={{ backgroundImage: Breakpoints.isAllMobile() ? `url(${BackgroundVertical})` : `url(${BackgroundHorizontal})` }}>
      <div className="content">
        <div className="col-12 form">
          <img alt="Logo" className="logo" src={Logo} />
          <h3 className="module-name">Módulo de atendimento</h3>
          <div className="module-description">Atendimento e visualização de senhas em espera</div>
          <div className="mt-3">
          <form method="post" onSubmit={submit}>
                    <div className="form-group p-0 col-md-6">
                    <FormLabelAndInput
                      label="Usuário"
                      name="username"
                      onChange={(event) => setAuth({ ...auth, username: event.target.value })}
                      type="text"
                      value={auth.username}
                    />
                    </div>
                    <div className="form-group p-0 col-md-6">
                    <FormLabelAndInput
                      label="Senha"
                      name="password"
                      onChange={(event) => setAuth({ ...auth, password: event.target.value })}
                      type="password"
                      value={auth.password}
                    />
                    </div>
                    <div className="form-group">
                          <div className="row button-row">
                              <div className="col">
                                <Button className="btn-primary btn-submit" text="Entrar" type="submit" />
                              </div>
                          </div>
                    </div>
                </form>
          </div>
        </div>
      </div>
      <img alt="Module logo" className="module-logo" src={ModuleLogo} />
      <Footer />
      <Messages />
    </div>

  );
}

Login.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired
};

export default Login;
